import React, { useState } from "react";
import {
  Box,
  Paper,
  TextField,
  Button,
  Typography,
  Container,
  Alert,
  CircularProgress,
  Tab,
  Tabs,
} from "@mui/material";
import {
  Login as LoginIcon,
  //   PersonAdd as RegisterIcon,
} from "@mui/icons-material";
import { useAuth } from "../contexts/AuthContext";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`auth-tabpanel-${index}`}
      aria-labelledby={`auth-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const AuthPage: React.FC = () => {
  const [tab, setTab] = useState(0);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    phone: "",
  });
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const {
    login,
    //register,
    loading,
  } = useAuth();

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
    setError(null);
    setSuccess(null);
    setFormData({ name: "", email: "", password: "", phone: "" });
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    if (!formData.email || !formData.password) {
      setError("Please fill in all required fields");
      return;
    }

    const result = await login(formData.email, formData.password);
    if (!result.success) {
      setError(result.error || "Login failed");
    }
  };

  //   const handleRegister = async (e: React.FormEvent) => {
  //     e.preventDefault();
  //     setError(null);
  //     setSuccess(null);

  //     if (!formData.name || !formData.email || !formData.password) {
  //       setError("Please fill in all required fields");
  //       return;
  //     }

  //     if (formData.password.length < 6) {
  //       setError("Password must be at least 6 characters long");
  //       return;
  //     }

  //     const result = await register(
  //       formData.name,
  //       formData.email,
  //       formData.password,
  //       formData.phone
  //     );

  //     if (!result.success) {
  //       setError(result.error || "Registration failed");
  //     } else {
  //       setSuccess("Registration successful! You are now logged in.");
  //     }
  //   };

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper elevation={4} sx={{ overflow: "hidden" }}>
        <Box
          sx={{
            bgcolor: "primary.main",
            color: "primary.contrastText",
            p: 3,
            textAlign: "center",
          }}
        >
          <Typography variant="h4" component="h1" gutterBottom>
            DocuSign POC
          </Typography>
          <Typography variant="subtitle1">
            Secure Document Management & E-Signature Platform
          </Typography>
        </Box>
        <Tabs
          value={tab}
          onChange={handleTabChange}
          variant="fullWidth"
          sx={{ borderBottom: 1, borderColor: "divider" }}
        >
          <Tab icon={<LoginIcon />} label="Login" />
          {/* <Tab icon={<RegisterIcon />} label="Register" /> */}
        </Tabs>
        {error && (
          <Box sx={{ p: 2 }}>
            <Alert severity="error" onClose={() => setError(null)}>
              {error}
            </Alert>
          </Box>
        )}
        {success && (
          <Box sx={{ p: 2 }}>
            <Alert severity="success" onClose={() => setSuccess(null)}>
              {success}
            </Alert>
          </Box>
        )}
        <TabPanel value={tab} index={0}>
          <Box component="form" onSubmit={handleLogin}>
            <Typography variant="h5" gutterBottom>
              Welcome Back
            </Typography>
            <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
              Sign in to access your document management dashboard
            </Typography>

            <TextField
              fullWidth
              label="Email"
              name="email"
              type="text"
              value={formData.email}
              onChange={handleInputChange}
              margin="normal"
              autoComplete="email"
              disabled={loading}
            />

            <TextField
              fullWidth
              label="Password"
              name="password"
              type="password"
              value={formData.password}
              onChange={handleInputChange}
              margin="normal"
              autoComplete="current-password"
              disabled={loading}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2, py: 1.5 }}
              disabled={loading}
              startIcon={
                loading ? <CircularProgress size={20} /> : <LoginIcon />
              }
            >
              {loading ? "Signing In..." : "Sign In"}
            </Button>
          </Box>
        </TabPanel>
        {/* <TabPanel value={tab} index={1}>
          <Box component="form" onSubmit={handleRegister}>
            <Typography variant="h5" gutterBottom>
              Create Account
            </Typography>
            <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
              Join our platform to start managing your documents
            </Typography>

            <TextField
              fullWidth
              label="Full Name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              margin="normal"
              required
              autoComplete="name"
              disabled={loading}
            />

            <TextField
              fullWidth
              label="Email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleInputChange}
              margin="normal"
              required
              autoComplete="email"
              disabled={loading}
            />

            <TextField
              fullWidth
              label="Phone (Optional)"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              margin="normal"
              autoComplete="tel"
              disabled={loading}
            />

            <TextField
              fullWidth
              label="Password"
              name="password"
              type="password"
              value={formData.password}
              onChange={handleInputChange}
              margin="normal"
              required
              autoComplete="new-password"
              helperText="Minimum 6 characters"
              disabled={loading}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2, py: 1.5 }}
              disabled={loading}
              startIcon={
                loading ? <CircularProgress size={20} /> : <RegisterIcon />
              }
            >
              {loading ? "Creating Account..." : "Create Account"}
            </Button>
          </Box>
        </TabPanel> */}
      </Paper>

      <Box sx={{ mt: 4, textAlign: "center" }}>
        <Typography variant="body2" color="textSecondary">
          Powered by DocuSign API • Secure • Reliable
        </Typography>
      </Box>
    </Container>
  );
};

export default AuthPage;
